(function () {
  const loadMoreBtns = document.querySelectorAll('.load-more-toplist');

  if (loadMoreBtns.length === 0) {
    return;
  }

  loadMoreBtns.forEach(btn => {
    let page = 1;
    const perPage = btn.getAttribute('data-per-page');
    const total = btn.getAttribute('data-total');
    const toplistId = btn.getAttribute('data-toplist-id');
    const params = JSON.parse(btn.getAttribute('data-params') ?? '{}');

    btn.addEventListener('click', function (event) {
      event.preventDefault();

      fetch(load_more_data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          nonce: load_more_data.nonce,
          locale: load_more_data.locale,
          page: page,
          perPage: perPage,
          total: total,
          toplistId: toplistId,
          params: JSON.stringify(params),
          action: 'more_operators'
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          return response.text();
        })
        .then(response => {
          page++;
          btn.previousElementSibling.insertAdjacentHTML('beforeend', response);

          if (page >= total) {
            btn.remove();
          } else {
            btn.disabled = false;
          }
        })
        .catch(error => {
          console.error('Error:', error);
          btn.disabled = false;
        });

      btn.disabled = true;
    });
  });
})();
